export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20warm%20gradient%20abstract%20background%20with%20soft%20coral%20red%20and%20dark%20warm%20tones%2C%20subtle%20geometric%20shapes%2C%20modern%20news%20media%20atmosphere%2C%20elegant%20depth%20with%20floating%20particles%2C%20editorial%20style%2C%20no%20text%2C%20no%20faces%2C%20atmospheric%20lighting&width=1920&height=1080&seq=hero-bg-51cg-x1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-6">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-primary-300 text-sm font-semibold whitespace-nowrap">今日最新爆料 · 实时追踪</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black leading-tight tracking-tight text-background-50 mb-5" style={{ fontFamily: 'var(--font-heading)' }}>
              51cg吃瓜网
              <br />
              <span className="text-primary-300">全网娱乐八卦一手掌握</span>
            </h1>

            <p className="text-base md:text-lg leading-relaxed text-background-200/90 max-w-2xl mb-4">
              聚焦全网最新爆料与热门事件，覆盖娱乐圈、直播圈、网红圈的独家消息。
            </p>
            <p className="text-sm md:text-base leading-relaxed text-background-300/80 max-w-2xl mb-8">
              51吃瓜官网全网最新发布平台，每日更新海量吃瓜内容。从当红明星动态到热门话题追踪，
              这里汇聚了最全、最快、最劲爆的第一手瓜源，满足每一位吃瓜群众的八卦需求。
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start mb-8">
              <div className="flex items-center gap-2 text-background-200 text-sm">
                <i className="ri-timer-flash-line text-primary-400 text-lg"></i>
                <span>每日更新 80+ 条</span>
              </div>
              <div className="flex items-center gap-2 text-background-200 text-sm">
                <i className="ri-group-line text-primary-400 text-lg"></i>
                <span>覆盖 50+ 热门话题</span>
              </div>
              <div className="flex items-center gap-2 text-background-200 text-sm">
                <i className="ri-shield-check-line text-primary-400 text-lg"></i>
                <span>独家渠道爆料</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line"></i>
                立即吃瓜
              </a>
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 backdrop-blur-sm border border-background-300/30 text-background-50 rounded-full font-medium text-sm whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                今日焦点
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photography%20style%20collage%20of%20entertainment%20and%20media%20elements%2C%20warm%20coral%20and%20deep%20red%20color%20palette%2C%20floating%20news%20headlines%20and%20social%20media%20icons%2C%20dynamic%20composition%2C%20modern%20abstract%20style%2C%20no%20faces%2C%20no%20text%2C%20artistic%20rendering&width=800&height=600&seq=hero-main-51cg-x2&orientation=landscape"
                alt="51cg吃瓜网 - 全网最新娱乐八卦资讯聚合平台"
                className="relative z-10 w-full h-auto rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}